import * as React from "react";
import DecoratorSummary from "views/components/messagelist/decorators/DecoratorSummary";
const formatDecorator = (decorator, decorators, decoratorTypes, updateFn) => {
  const typeDefinition = decoratorTypes[decorator.type] || { requested_configuration: {}, name: `Unknown type: ${decorator.type}` };
  const onUpdate = updateFn ? (id2, updatedDecorator) => updateFn(decorators.map((curDecorator) => curDecorator.id === id2 ? updatedDecorator : curDecorator)) : () => {
  };
  const onDelete = updateFn ? (deletedDecoratorId) => updateFn(decorators.filter(({ id: id2 }) => id2 !== deletedDecoratorId)) : () => {
  };
  const { id, order } = decorator;
  return {
    id,
    order,
    title: /* @__PURE__ */ React.createElement(
      DecoratorSummary,
      {
        key: `decorator-${id || "new"}`,
        decorator,
        decoratorTypes,
        disableMenu: updateFn === void 0,
        onUpdate,
        onDelete,
        typeDefinition
      }
    )
  };
};
export default formatDecorator;
